// component

import { ShopLinks } from "src/packages/shop/routes/ShopLinks";
import { BillPresentMentLinks } from "../../../../packages/bill-presentment/routes/links";
import { CommissionLinks } from '../../../../packages/dealer/routes/CommissionLink';

const subNavConfig = [...ShopLinks]

export const paybillLinks = [...ShopLinks, ...BillPresentMentLinks]

export const dealerLinks = [...ShopLinks, ...CommissionLinks]

export default subNavConfig;
